var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    viewBox: "0 0 91 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0659 3.26953C49.2286 1.27148 47.4591 0 45.5159 0C43.5727 0 41.819 1.27148 40.9659 3.26953L30.8074 27.3006L8.12059 31.1514C6.22476 31.4783 4.6449 33.0041 4.06035 35.093C3.4758 37.1818 3.94976 39.4887 5.30844 41.0326L21.7706 59.7598L17.8841 86.2248C17.5682 88.4045 18.3581 90.6205 19.9222 91.9102C21.4862 93.1998 23.5558 93.3633 25.2621 92.3279L45.5317 79.8855L65.8013 92.3279C67.5076 93.3633 69.5772 93.218 71.1413 91.9102C72.7053 90.6023 73.4953 88.4045 73.1793 86.2248L69.277 59.7598L85.7392 41.0326C87.0979 39.4887 87.5876 37.1818 86.9873 35.093C86.3869 33.0041 84.8229 31.4783 82.927 31.1514L60.2244 27.3006L50.0659 3.26953Z",
    fill: "#264A80",
    fillOpacity: 0.68
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.d024285288a4da1c3094a66fb576c611.svg";
export { ForwardRef as ReactComponent };